import React, { useState } from 'react'
import type { ProductType } from '@/types'
import TabStripExperiment from './TabStripExperiment'
import { PRODUCT_TABS_EXPERIMENT } from '../SearchForm/constants'
import getProductCategory from './utils/getProductCategory'

export default function SearchFormExperimentWrapper({
  currentTab,
  onFormChange
}: {
  currentTab: ProductType
  onFormChange: (productType: ProductType) => void
}) {
  const [formState, setFormState] = useState(getProductCategory(currentTab))
  const handleOnTabClick = (productType: ProductType) => {
    if (productType === currentTab) {
      return
    }
    const selectedProductCategory = getProductCategory(productType)
    setFormState(selectedProductCategory)
    onFormChange(productType)
  }
  return (
    <div className="w-full">
      <div className="my-4 p-4 justify-center gap-4">
        <TabStripExperiment
          initialActiveTab={currentTab}
          onTabClick={handleOnTabClick}
          productTabs={PRODUCT_TABS_EXPERIMENT}
        />
        {formState.component}
      </div>
    </div>
  )
}
